import styled from "styled-components";

function handleColorType(color, theme) {
  switch (color) {
    case "red":
      return theme.colors.RED;

    case "green":
      return theme.colors.GREEN;
    case "blue":
      return theme.colors.BLUE;
    case "grey":
      return theme.colors.GREY_2;
    default:
      return "#FFF";
  }
}

export const Button = styled.button`
  border-radius: 1rem;
  background-color: ${(props) => handleColorType(props.color, props.theme)};
  border: none;
  font-weight: 700;
  cursor: pointer;
  color: ${(props) => props.theme.colors.WHITE};
  font-size: 3rem;
  padding: 2rem 3rem;

  > * {
    vertical-align: middle;
    display: inline-block;
    margin: 0 1rem;
  }

  :focus {
    outline: none;
  }
  :disabled {
    cursor: not-allowed;
  }
`;
